import React, { useState } from "react";
import ResetPasswordForm from "./ResetPasswordForm"
import {connect} from "react-redux";
import { resetPassword } from '../../redux';
import { useParams, useNavigate } from "react-router-dom";

function ResetPasswordFormContainer (props) {
    const {
        resetPassword,
        authErrCode,
    } = props;

    // The route is "/reset/*", so the emailed token lands in the splat param.
    const resetToken = useParams()["*"];
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState("");
    const [newPasswordRepeat, setNewPasswordRepeat] = useState("");
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        const stateSetter = 
            e.target.name === "newPassword" ? setNewPassword :
            e.target.name === "newPasswordRepeat" ? setNewPasswordRepeat :
            null;

        stateSetter(e.target.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== newPasswordRepeat) {
            setMessage("Passwords did not match.");
            return;
        }
        if (!newPassword) {
            setMessage("Please enter a new password.");
            return;
        }
        if (!resetToken) {
            setMessage("This reset link is missing its token. Please request a new password reset email.");
            return;
        }

        setMessage("");
        // Only claim success once the server has confirmed it — otherwise the user
        // walks away thinking the password changed when it didn't.
        const succeeded = await resetPassword(newPassword, resetToken);

        if (succeeded) {
            alert("Your password was successfully changed.");
            navigate("/login");
        } else {
            setMessage("We couldn't reset your password. This link may have expired — please request a new password reset email.");
        }
    }

    return (
        <ResetPasswordForm
            newPassword={newPassword}
            newPasswordRepeat={newPasswordRepeat}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            errMsg={message || (authErrCode.changePassword > 499 ? "Server error!" : "")}/>
        )
}

export default connect(state => state.root, { resetPassword })(ResetPasswordFormContainer);
